export function interpretWeatherApiError(code) {
    switch (code) {
      case 1006:
        return "City not found, please try again.";
      case 1003:
        return "Kein Ort angegeben.";
      case 1002:
      case 2006:
      case 2008:
        return "API-Schlüssel ungültig oder deaktiviert.";
      case 2007:
      case 2009:
        return "Zugriff verweigert oder Limit erreicht.";
      case 1005:
      case 9000:
      case 9001:
      case 9999:
        return "Interner Fehler. Bitte später versuchen.";
      default:
        return "Unbekannter Fehler.";
    }
  }
  